module.exports = __webpack_public_path__ + "media/images/background-success-3a032f5affb9760fce2e00270c4e7c92.webp";